import React from 'react'
import { connect } from 'react-redux'
import { EntityTypeEnum, FatFingerUserLimit, FatFingerUserLimitDetail, TradingEntityMeta, WorkflowActions, WorkflowDetail } from 'api'
import { ActionItem, SplitButtonDropdown } from 'view/components/menus'
import { ActionsButtonProps } from 'view/components/datagrid'
import { ModalConsumerProps, withModal } from 'view/shared/modal'
import { NotificationActions, NotificationType, ShowDialogArgs } from 'store/notification'
import { Locale, Translation } from 'locale'
import { FatFingerLimitDialog } from '../FatFingerLimitDialog'

export interface FatFingerUserLimitActionsButtonProps
  extends ModalConsumerProps,
    ActionsButtonProps<WorkflowDetail<FatFingerUserLimitDetail>> {
  onShowDialog: (dialogArgs: ShowDialogArgs) => unknown
  context: {
    workflowId: string
    tradingEntityId: string
    organisationId: string
    tradingEntityMetas: TradingEntityMeta[]
    existingFatFingerUserLimitIds: string[]
  }
}

const mapStateToProps = null

const mapDispatchToProps = {
  onShowDialog: NotificationActions.showDialog
}

const FatFingerLimitActionsButtonComponent: React.FunctionComponent<FatFingerUserLimitActionsButtonProps> = props => {
  const {
    items,
    onShowDialog,
    showModal,
    context: { workflowId, organisationId, existingFatFingerUserLimitIds }
  } = props

  const handleShowItemDialog = (fatFingerLimitDetails: FatFingerUserLimit[]) => {
    const fatFingerLimit = fatFingerLimitDetails[0]
    showModal(
      <FatFingerLimitDialog
        existingFatFingerLimitIds={existingFatFingerUserLimitIds}
        organisationId={organisationId}
        entityId={fatFingerLimit.id}
        workflowId={workflowId}
        userId={fatFingerLimit.userId}
      />
    )
  }

  const handleDelete = (fatFingerLimitDetails: FatFingerUserLimitDetail[]) => {
    const titleText = Locale.translate(Translation.TC_PROMPT_TITLE_DELETE_FAT_FINGER_LIMIT, { count: 1 })

    const messageText = Locale.translate(Translation.SC_PROMPT_MSG_DELETE_SINGLE_FAT_FINGER_LIMIT, { name: items[0].productSector?.name })

    const deleteActions = [
      WorkflowActions.createEntityDeleteReferenceData(
        [
          {
            entityType: EntityTypeEnum.FAT_FINGER_USER,
            entityId: fatFingerLimitDetails[0].fatFingerUserLimit.id
          }
        ],
        workflowId
      )
    ]

    onShowDialog({
      type: NotificationType.Confirm,
      titleText: titleText,
      messageText: messageText,
      buttons: [Translation.TC_BUTTON_YES, Translation.TC_BUTTON_NO],
      defaultButton: Translation.TC_BUTTON_YES,
      cancelButton: Translation.TC_BUTTON_NO,
      responseMap: {
        [Translation.TC_BUTTON_YES]: deleteActions
      }
    })
  }

  const actions: ActionItem[] = [
    {
      label: Locale.translate(Translation.TC_ACTION_EDIT_DETAILS),
      onClick: () => handleShowItemDialog(items.map(element => element.fatFingerUserLimit)),
      enabled: items.length === 1
    },
    {
      label: Locale.translate(Translation.TC_ACTION_DELETE, items.length),
      onClick: () => handleDelete(items),
      enabled: items.length > 0
    }
  ]

  return <SplitButtonDropdown dataTestId={'FatFingerLimitsActionsButton'} actions={actions} maxButtons={1} />
}

export const FatFingerUserLimitActionsButton = withModal(connect(mapStateToProps, mapDispatchToProps)(FatFingerLimitActionsButtonComponent))
